import { useMutation, useQuery } from 'react-query'
import { get } from 'framework/api/http'

import {
  buildSsccXmlListParams,
  SsccXmlListQueryVariables,
} from './useGetSsccXmlValidationList'

export interface SsccXmlAllQueryVariables extends SsccXmlListQueryVariables {
  /** yyyy-MM-dd, inclusive */
  from?: string
  /** yyyy-MM-dd, inclusive */
  to?: string
}

const allParams = (vars: SsccXmlAllQueryVariables) => {
  const params = buildSsccXmlListParams(vars)
  if (vars.from) params.append('from', vars.from)
  if (vars.to) params.append('to', vars.to)
  return params
}

/* BDL20-4003: every SSCC XML sent to T&W (All SSCC XML tab) */
export const getSsccXmlAllList = async (queryData: any) => {
  const vars = queryData.queryKey[1] as SsccXmlAllQueryVariables
  const res = await get(`/TnW/SsccXml/All?${allParams(vars).toString()}`)
  return res.data
}

export const useGetSsccXmlAllList = (
  queryData: SsccXmlAllQueryVariables,
  options?: { enabled?: boolean },
) => {
  return useQuery(['ssccXmlAll', queryData], getSsccXmlAllList, {
    refetchOnWindowFocus: true,
    keepPreviousData: true,
    enabled: options?.enabled ?? true,
  })
}

/* BDL20-4003: Download CSV — the current filters, all pages */
export const useExportSsccXmlAll = () => {
  return useMutation((vars: Omit<SsccXmlAllQueryVariables, 'take' | 'skip'>) =>
    get(
      `/TnW/SsccXml/All/Export?${allParams({
        ...vars,
        take: 0,
        skip: 0,
      }).toString()}`,
      { responseType: 'blob' },
    ),
  )
}
